module.exports = __webpack_public_path__ + "media/src/images/header/logo-4a92e11dfc8dd0bd3ad2fb502df6cdba.png";